module.exports = __webpack_public_path__ + "img/coupon.98b5867f.png";